import { formatDate } from '@angular/common';
import { Component,Inject,Input,LOCALE_ID,OnDestroy,OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog,MatDialogConfig,MatDialogRef,MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Actions,ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import moment,{ Moment } from 'moment';
import { BehaviorSubject,combineLatest,firstValueFrom,merge,Observable,of,Subscription,switchMap } from 'rxjs';
import { debounceTime,distinctUntilChanged,filter,map,shareReplay,skip,tap } from 'rxjs/operators';
import { CustomerEntity } from '../../../../dave-data-module/entities/customer.entity';
import { ContractParticipantEntity } from '../../../../dave-data-module/entities/mdqx/contract-participant.entity';
import { CustomerResolver } from '../../../../dave-data-module/guards/customer.resolver';
import {
CustomerSpecificationTypeResolver
} from '../../../../dave-data-module/guards/customerSpecificationType.resolver';
import { FrontendDate } from '../../../../dave-data-module/helper/backend-frontend-conversion.helper';
import { getFetched$ } from '../../../../dave-data-module/helper/helper';
import { MutationCreateContractParticipantArgs } from '../../../../dave-data-module/mdqx-graphql-types';
import { State } from '../../../../dave-data-module/State';
import { BaseActionTypes } from '../../../../dave-data-module/State/actions/base.actions';
import { CustomerActionTypes } from '../../../../dave-data-module/State/actions/customers.actions';
import {
ContractParticipantActionTypes,
DeleteContractParticipantRequest,
PostContractParticipantRequest
} from '../../../../dave-data-module/State/actions/mdqx/contract-participant.actions';

import { getCustomerById,getCustomerDictionary,getCustomers,getCustomersFetched } from '../../../../dave-data-module/State/selectors/customers.selectors';
import {
getCustomerSpecificationTypes,getCustomerSpecificationTypesFetched
} from '../../../../dave-data-module/State/selectors/customerSpecificationType.selectors';
import { getContractParticipants,getContractParticipantsFetched } from '../../../../dave-data-module/State/selectors/mdqx/selectors';
import { ISelectedElement,ITableConfig,TableContentType } from '../../../../dave-select-user/components/multi-select-table/multi-select-table.component';
import { SelectUserDialogBase } from '../../../../dave-select-user/components/select-user-dialogs/select-user-dialog-base';
import { FilterOption,FILTER_TYPE_MULTI_SELECT } from '../../../../dave-utils-module/app-filter-module/app-filter/app-filter.component';
import {
DetailListDialogReturn,
DetailListTemplateDialogComponent,DetailListTemplateDialogData
} from '../../../../detail-list-template-dialog/components/detail-list-template-dialog.component';
import { isNotNullOrUndefined,SearchQueriesDebounceTime,stringSearch } from '../../../../helper/helper';
import { CustomerAdministrationMeta } from '../../../../helper/page-metadata';
import { CustomLabelService } from '../../../../services/custom-label.service';
import { DefaultFilterService,FilterApps } from '../../../../services/default-filter.service';
import { LoadingService } from '../../../../services/loading.service';

interface ITableData {
    customerId: number;
    selectedForm: FormControl<boolean>;
    specificationTypeId: number;
    name: TableContentType<{ id: string }> & { __typename: 'string' };
    number: TableContentType<{ id: string }> & { __typename: 'string' };
    entryDate: TableContentType<{ id: string }> & { __typename: 'date' };
    endDate: TableContentType<{ id: string }> & { __typename: 'date' };
    ausnahmedatum: TableContentType<{ id: string }> & { __typename: 'date' };
}
interface SelectedCustomerType extends ISelectedElement {
    contractParticipantId: number;
    customerId: number;
}
enum filterNames {
    customerSpecType = 'customerSpecificationType',
}
interface IFilter {
    [filterNames.customerSpecType]: string[];
}
export interface SelectCustomerComponentPreFilter {
    customerSpecificationTypeIds: number[];
}
export interface SelectCustomersForContractDialogData {
    contractId?: number;
    customer?: CustomerEntity;
}
@Component({
    selector: 'app-select-customers-for-contract-dialog',
    templateUrl: './select-customers-for-contract-dialog.component.html',
    styleUrls: ['./select-customers-for-contract-dialog.component.scss'],
})
export class SelectCustomersForContractDialogComponent implements OnInit, OnDestroy {
    public static readonly DefaultConfig: MatDialogConfig = SelectUserDialogBase.DefaultConfig;
    public FilterSettings$: Observable<FilterOption[]> = this.store.select(getCustomerSpecificationTypesFetched).pipe(
        filter((f) => f),
        switchMap(() => this.store.select(getCustomerSpecificationTypes)),
        map((customerTypes) => {
            const ctValues = {};
            customerTypes.forEach((c) => {
                ctValues[c.Id.toString()] = c.Name;
            });
            return [
                {
                    Name: filterNames.customerSpecType,
                    Type: FILTER_TYPE_MULTI_SELECT,
                    Label: 'Kundenart',
                    Values: ctValues,
                },
            ];
        }),
    );
    public FilterValues$: BehaviorSubject<IFilter> = new BehaviorSubject({
        [filterNames.customerSpecType]: [],
    });
    private preFilter$ = new BehaviorSubject<SelectCustomerComponentPreFilter | null>(null);
    @Input() set preFilter(value: SelectCustomerComponentPreFilter) {
        this.preFilter$.next(value);
    }
    get preFilter(): SelectCustomerComponentPreFilter {
        return this.preFilter$.value;
    }
    public FilterAmount$ = this.FilterValues$.pipe(map((v) => (v[filterNames.customerSpecType]?.length ? 1 : 0)));
    public SearchString: BehaviorSubject<string> = new BehaviorSubject<string>('');

    selectedCustomers$: Observable<SelectedCustomerType[] | null>;

    TableDataConfig: ITableConfig[] ;
    FilteredTableData$: Observable<ITableData[]>;
    TableData$: Observable<ITableData[]>;

    private subscriptions: Subscription[] = [];
    protected isChildCustomer = false;
    public ContentResolved$: Observable<boolean>;
    public dirty = false;
    public contractId: number;
    private customer: CustomerEntity;
    private contractParticipantsByContract$: Observable<ContractParticipantEntity[]>;
    constructor(
        private store: Store<State>,
        public LS: LoadingService,
        private defaultFilter: DefaultFilterService,
        customerRes: CustomerResolver,
        customerSpecTypeRes: CustomerSpecificationTypeResolver,
        protected cls: CustomLabelService,
        @Inject(MAT_DIALOG_DATA) data: SelectCustomersForContractDialogData,
        @Inject(LOCALE_ID) locale: string,
        private actions$: Actions,
        private dialogRef: MatDialogRef<SelectCustomersForContractDialogComponent>,
        private dialog: MatDialog,
    ) {
        this.contractId = data.contractId ?? null;
        if(this.contractId === null) {
            this.customer = data.customer;
            if(data.customer?.ParentId){
                this.isChildCustomer = true;
            }
            this.TableDataConfig = [
                {
                    header: 'Kundennummer',
                    id: 'number',
                    sortAccessor: (cell: TableContentType<any> & { __typename: 'string' }) => cell.content || '',
                },
                {
                    header: 'Name',
                    id: 'name',
                    sortAccessor: (cell: TableContentType<any> & { __typename: 'string' }) => cell.content || '',
                }
            ];
        }else{
           this.TableDataConfig = [
               {
                   header: 'Kundennummer',
                   id: 'number',
                   sortAccessor: (cell: TableContentType<any> & { __typename: 'string' }) => cell.content || '',
               },
               {
                   header: 'Name',
                   id: 'name',
                   sortAccessor: (cell: TableContentType<any> & { __typename: 'string' }) => cell.content || '',
               },
               {
                   header: 'Beitrittsdatum',
                   id: 'entryDate',
                   width: '9.5rem',
               },
               {
                   header: 'Teilnahmeende',
                   id: 'endDate',
                   width: '9.5rem',
               },
               {
                   header: 'Ausnahmedatum',
                   id: 'ausnahmedatum',
                   width: '9.5rem',
               },
           ];
        }
        this.ContentResolved$ = combineLatest([
            this.store.select(getCustomersFetched).pipe(
                distinctUntilChanged(),
                tap((fetched) => {
                    if (!fetched) {
                        customerRes.resolve();
                    }
                }),
            ),
            this.store.select(getCustomerSpecificationTypesFetched).pipe(
                distinctUntilChanged(),
                tap((fetched) => {
                    if (!fetched) {
                        customerSpecTypeRes.resolve();
                    }
                }),
            ),
        ]).pipe(
            map((values) => values.every((v) => v)),
            distinctUntilChanged(),
            shareReplay({ refCount: true, bufferSize: 1 }),
        );
        this.contractParticipantsByContract$ = this.contractId
            ? getFetched$(this.store, getContractParticipantsFetched, getContractParticipants).pipe(
                map((cps) => cps.filter((c) => c.ContractId === this.contractId)),
                shareReplay({ refCount: true, bufferSize: 1 }),
            )
            : of([]);

        if(data.customer) {

        if(data.customer?.ParentId){
            this.selectedCustomers$ = this.store.select(getCustomers).pipe(
                map((customers) => {
                    const parent = customers.find((c) => c.Id === data.customer.ParentId);
                    if (!parent) return [];
                    return [
                        {
                            contractParticipantId: null,
                            customerId: parent.Id,
                            label: parent.DisplayName,
                        } as SelectedCustomerType,
                    ];
                })
            );
        }else{
            this.selectedCustomers$ = this.store.select(getCustomers).pipe(
                map((customers) => {
                    const children = customers.filter((c) => c.ParentId === data.customer?.Id);
                    return children
                        .map<SelectedCustomerType>((child) => ({
                            contractParticipantId: null,
                            customerId: child.Id,
                            label: child.DisplayName,
                        }))
                        .sort((a, b) => a.label.localeCompare(b.label));
                })
            );
        }
        }else{
            this.selectedCustomers$ = this.contractParticipantsByContract$.pipe(
                switchMap((cps) =>
                    getFetched$(this.store, getCustomersFetched, getCustomerDictionary).pipe(
                        map((customers) => {
                            return cps.map<SelectedCustomerType>((c) => ({
                                contractParticipantId: c.Id,
                                customerId: c.CustomerId,
                                label: `${customers[c.CustomerId]?.DisplayName ?? ''}${
                                    c.EntryDate && c.EndDate
                                        ? ` (${formatDate(c.EntryDate, 'shortDate', locale)} - ${formatDate(c.EndDate, 'shortDate', locale)})`
                                        : c.EntryDate
                                            ? ` Beitrittsdatum: ${formatDate(c.EntryDate, 'shortDate', locale)}`
                                            : c.EndDate ? ` Teilnahmeende: ${formatDate(c.EndDate, 'shortDate', locale)}` : ''
                                }${
                                    c.Ausnahmedatum
                                        ? ` Ausnahmedatum: ${formatDate(c.Ausnahmedatum, 'shortDate', locale)}`
                                        : ''
                                }`,
                            })).sort((a, b) => a.label.localeCompare(b.label));
                        }),
                    ),
                ),
            );
        }
        // this.store.select(getCustomerDictionary).pipe(map((customers) => (this.Dialogdata.selectedCustomers || []).map((id) => ({ label: customers[id]?.DisplayName, customerId: id }))));
        this.TableData$ = combineLatest([
            this.contractParticipantsByContract$,
            this.store.select(getCustomersFetched).pipe(
                filter((v) => !!v),
                switchMap(() => this.store.select(getCustomers)),
                map((customers) => customers.filter((c) => !c.Deleted)),
            ),
            this.preFilter$,
        ]).pipe(
            map(([contractParticipants, customers, preFilter]) => {
                const filteredCustomers =
                    preFilter && preFilter.customerSpecificationTypeIds?.length
                        ? customers.filter((customer) => customer.CustomerSpecificationTypeId && preFilter.customerSpecificationTypeIds.includes(customer.CustomerSpecificationTypeId))
                        : customers;
                return filteredCustomers.map<ITableData>((c) => {
                    const cp: ContractParticipantEntity = contractParticipants.find((cp) => cp.CustomerId === c.Id);
                    // const type = c.CustomerTypeIds && types.find((ct) => ct.Id === c.CommissionTypeId);
                    return {
                        customerId: c.Id,
                        specificationTypeId: c.CustomerSpecificationTypeId,
                        selectedForm: new FormControl<boolean>(!!cp),
                        name: {
                            __typename: 'string',
                            content: c.DisplayName,
                        },
                        number: {
                            __typename: 'string',
                            content: c.CustomerNo,
                        },
                        entryDate: {
                            __typename: 'date',
                            formControl: new FormControl<Moment>(cp ? (cp.EntryDate ? moment(cp?.EntryDate) : null) : moment()),
                        },
                        endDate: {
                            __typename: 'date',
                            formControl: new FormControl<Moment>(cp?.EndDate ? moment(cp.EndDate) : null),
                        },
                        ausnahmedatum: {
                            __typename: 'date',
                            formControl: new FormControl<Moment>(cp?.Ausnahmedatum ? moment(cp.Ausnahmedatum) : null),
                        },
                    };
                });
            }),
            shareReplay({ refCount: true, bufferSize: 1 }),
        );
        this.FilteredTableData$ = this.TableData$.pipe(
            switchMap((rows) =>
                this.FilterValues$.pipe(map((filter) => (filter[filterNames.customerSpecType]?.length ? rows.filter((row) => row.specificationTypeId && filter[filterNames.customerSpecType].includes(row.specificationTypeId.toString())) : rows))),
            ),
            switchMap((rows) => {
                return this.SearchString.pipe(
                    debounceTime(SearchQueriesDebounceTime),
                    map((searchString) => (!searchString && rows) || rows.filter((r) => [r.name.content, r.number.content].filter(isNotNullOrUndefined).some((s) => stringSearch(s, searchString)))),
                );
            }),
            shareReplay({ refCount: true, bufferSize: 1 }),
        );
    }
    ngOnInit(): void {
        firstValueFrom(this.defaultFilter.GetFilterByApp$(FilterApps.MDQXSelectCustomerForContractPopup)).then((filterValues) => {
            let temp = {
                [filterNames.customerSpecType]: isNotNullOrUndefined(filterValues[filterNames.customerSpecType]) ? filterValues[filterNames.customerSpecType] : [],
            };
            this.FilterValues$.next(temp);
        });

        this.subscriptions.push(
            this.FilterValues$.pipe(skip(2)).subscribe((val) => {
                if (Object.keys(val).length !== 0) {
                    this.defaultFilter.SetFilterByApp(FilterApps.MDQXSelectCustomerForContractPopup, val);
                }
            }),
            this.TableData$.pipe(
                // tap(() => this.dirty = false),
                switchMap((td) => merge(...td.map((t) => t.selectedForm.valueChanges.pipe(map(() => t.selectedForm.dirty))))),
            ).subscribe((v) => {
                if (v) {
                    this.dirty = true;
                }
            }),
            this.TableData$.pipe(
                switchMap((data) =>
                    this.selectedCustomers$.pipe(
                        tap((selectedCustomers) =>
                            data.forEach((d) => {
                                const isSelected = selectedCustomers.some((u) => u.customerId === d.customerId);
                                if (isSelected && (d.selectedForm.enabled || !d.selectedForm.value)) {
                                    d.selectedForm.setValue(true, { emitEvent: false });
                                    d.selectedForm.disable();
                                    d.entryDate.formControl.disable();
                                    d.endDate.formControl.disable();
                                    d.ausnahmedatum.formControl.disable();
                                } else if (!isSelected && (d.selectedForm.disabled || d.selectedForm.value)) {
                                    d.selectedForm.setValue(false, { emitEvent: false });
                                    d.selectedForm.enable();
                                    d.entryDate.formControl.enable();
                                    d.endDate.formControl.enable();
                                    d.ausnahmedatum.formControl.enable();
                                }
                            }),
                        ),
                    ),
                ),
            ).subscribe(),
        );
    }
    async RemoveSelected(entity: SelectedCustomerType) {
        this.store.dispatch(
            new DeleteContractParticipantRequest({
                id: entity.contractParticipantId,
            }),
        );
    }
    async clickSelected(entity: SelectedCustomerType) {
        // alert('not implemented')
        const cps = await firstValueFrom(this.contractParticipantsByContract$);
        const cp = cps.find(c => c.CustomerId === entity.customerId);
        if (cp) {
            this.dialog
                .open<DetailListTemplateDialogComponent, DetailListTemplateDialogData, DetailListDialogReturn>(DetailListTemplateDialogComponent, {
                    ...DetailListTemplateDialogComponent.DefaultConfig,
                    data: {
                        Data: {
                            Properties: [
                                {
                                    key: 'Beitrittsdatum',
                                    formControl: new FormControl<Moment>(moment(cp.EntryDate)),
                                    options: {
                                        specialInput: {
                                            date: true,
                                        },
                                    },
                                },
                                {
                                    key: 'Teilnahmeende',
                                    formControl: new FormControl<Moment>(moment(cp.EndDate)),
                                    options: {
                                        specialInput: {
                                            date: true,
                                        },
                                    },
                                },
                                {
                                    key: 'Ausnahmedatum',
                                    formControl: new FormControl<Moment>(moment(cp.Ausnahmedatum)),
                                    options: {
                                        specialInput: {
                                            date: true,
                                        },
                                    },
                                },
                            ],
                        },
                        Editing: true,
                    },
                })
                .afterClosed()
                .subscribe((ret) => {
                    if (ret?.Action === 'save') {
                        this.RemoveSelected(entity);
                        this.store.dispatch(
                            new PostContractParticipantRequest({
                                contractId: this.contractId,
                                customerId: entity.customerId,
                                entryDate: (() => {
                                    const val = ret.DialogData.Data.Properties[0].formControl.value;
                                    if (!val || !val.isValid()) return null;
                                    const date = val.toDate ? val.toDate() : val; // falls already Date
                                    return FrontendDate(date);
                                })(),
                                endDate: (() => {
                                    const val = ret.DialogData.Data.Properties[1].formControl.value;
                                    if (!val || !val.isValid()) return null;
                                    const date = val.toDate ? val.toDate() : val;
                                    return FrontendDate(date);
                                })(),
                                ausnahmedatum: (() => {
                                    const val = ret.DialogData.Data.Properties[2].formControl.value;
                                    if (!val || !val.isValid()) return null;
                                    const date = val.toDate ? val.toDate() : val;
                                    return FrontendDate(date);
                                })(),
                            }),
                        );
                    } else if (ret?.Action === 'delete') {
                        this.RemoveSelected(entity);
                    }
                });
        }
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach((s) => s.unsubscribe());
    }
    protected readonly CustomerAdministrationMeta = CustomerAdministrationMeta;

    async Submit() {
        this.LS.startLoading('app-select-customers-for-contract-dialog_submit');
        const tableData = await firstValueFrom(this.TableData$);
        const alreadySelected = await firstValueFrom(this.selectedCustomers$);
        const toAdd: Array<MutationCreateContractParticipantArgs> = [];
        tableData.forEach(d => {
            if (d.selectedForm.value && !alreadySelected.some(s => s.customerId === d.customerId)) {
                toAdd.push({
                    customerId: d.customerId,
                    contractId: this.contractId,
                    entryDate: d.entryDate.formControl.value ? FrontendDate(d.entryDate.formControl.value.toDate()) : null,
                    endDate: d.endDate.formControl.value ? FrontendDate(d.endDate.formControl.value.toDate()) : null,
                    ausnahmedatum: d.ausnahmedatum.formControl.value ? FrontendDate(d.ausnahmedatum.formControl.value.toDate()) : null,
                })
            }
        });
        let error = false;
        if (this.contractId) {


        if (toAdd.length > 0) {
            toAdd.forEach(Payload => {
                this.store.dispatch(
                    new PostContractParticipantRequest(Payload),
                );
            });
            await firstValueFrom(this.actions$.pipe(ofType(BaseActionTypes.ErrorAction, ContractParticipantActionTypes.PostResponse), tap(action => {
                if (action.type === BaseActionTypes.ErrorAction.type) {
                    error = true;
                }
            }), skip(toAdd.length - 1)))
        }
        this.LS.endLoading('app-select-customers-for-contract-dialog_submit');
        if (!error) {
            this.dialogRef.close()
        }
        }else{
            if(!this.customer?.ParentId){
                if (toAdd.length > 0) {
                    for (const Payload of toAdd) {
                        const cust = await firstValueFrom(this.store.select(getCustomerById({ id: Payload.customerId })));
                        this.store.dispatch(
                            CustomerActionTypes.ModifyCustomer({ Payload: { id: cust.Id, parentId: this.customer.Id, customerStatus: cust.CustomerStatus, gerichtsort: cust.Gerichtsort, partnerOfficeId: cust.PartnerOfficeId } }),
                        );
                    }
                }
                this.LS.endLoading('app-select-customers-for-contract-dialog_submit');
                if (!error) {
                    this.dialogRef.close()
                }
            }
        }
    }
}
